import { XingletLoader } from '@xing-com/crate-xinglet';

import { PlayerProps } from '../../types/player';

export const Player: React.FC<PlayerProps> = (props) => {
  return (
    <XingletLoader name="@xing-com/crate-video-player-xinglet" {...props} />
  );
};
